import { Box, Typography } from '@mui/material'
import React from 'react'

interface Props {
  label: string
  value?: string
  Icon?: React.ElementType
  variant?: 'primary' | 'secondary'
}

export const Item = ({ label, value, Icon, variant = 'primary' }: Props) => {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      {Icon && <Icon color="action" />}
      <Box>
        <Typography variant="subtitle2" color="text.secondary">
          {label}
        </Typography>
        <Typography
          variant="body2"
          color={variant === 'primary' ? 'text.primary' : 'text.secondary'}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  )
}

export default Item
